export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '姓名',
    dataIndex: 'real_name',
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
  },
  {
    title: '所属单位',
    dataIndex: 'qichacha_name',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index) =>
      record.status === 0 ? '禁用' : '启用',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },
];

export const formData1 = [
  {
    name: 'role',
    lable: '账户角色',
    lableCol: '',
    wrapperCol: '',
    offset: 0,
    span: 12,
  },
  {
    name: 'company_id',
    lable: '所属单位',
    lableCol: '',
    wrapperCol: '',
    offset: 2,
    span: 12,
  },
  {
    name: 'real_name',
    lable: '姓名',
  },
  {
    name: 'phone',
    lable: '手机号',
  },
  {
    name: 'pwd_new',
    lable: '密码',
  },
  {
    name: 'province',
    lable: '省份',
  },
  {
    name: 'city',
    lable: '城市',
  },
  {
    name: 'address',
    lable: '详细地址',
  },
];
